import { IStorage } from './IStorage';

/**
 * LocalStorage implementation of IStorage
 * Works in both web browsers and Electron renderer process
 */
export class LocalStorageAdapter implements IStorage {
  private readonly prefix: string = 'collab_';

  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(this.prefix + key, value);
    } catch (error) {
      console.error(`Failed to set item ${key}:`, error);
      throw error;
    }
  }

  getItem(key: string): string | null {
    try {
      return localStorage.getItem(this.prefix + key);
    } catch (error) {
      console.error(`Failed to get item ${key}:`, error);
      return null;
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(this.prefix + key);
    } catch (error) {
      console.error(`Failed to remove item ${key}:`, error);
    }
  }

  clear(): void {
    try {
      // Only clear items with our prefix
      const keys = Object.keys(localStorage);
      const collabKeys = keys.filter(key => key.startsWith(this.prefix));
      collabKeys.forEach(key => localStorage.removeItem(key));
    } catch (error) {
      console.error('Failed to clear storage:', error);
    }
  }

  hasItem(key: string): boolean {
    try {
      return localStorage.getItem(this.prefix + key) !== null;
    } catch (error) {
      console.error(`Failed to check item ${key}:`, error);
      return false;
    }
  }
}